import layout from '@/layouts/link-block.vue'
import importAllImages from '@/functions/importAllImages.js'

import IconSpeakerPodium from '@/components/icons/icon-speaker-podium.vue'
import IconSpeechbubble from '@/components/icons/icon-speechbubble.vue'
import IconShoppingcartAdd from '@/components/icons/icon-shoppingcart-add.vue'



// headline: YOU AND JT
// overline: Don't miss the Johnathan Thurston farewell phenomenon. Say #ThanksJT on social, plus...
// Get the book: https://www.booktopia.com.au/jt-johnathan-thurston/prod9781460752609.html
// Catch the speaking tour: https://www.majoreventscompany.com/shows
// Send your personal message to JT: hyperlink to come

export default {
  version: '1.1.4',
  layout,
  showDump: false,
  custom: {},

  // !! WARNING !!
  // This function imports all images, regardless of whether they are used or not
  // be sure to move unused images to a different location
  allImages: importAllImages(require.context('../images', false, /\.js/)),

  header: {
    title: 'You and JT',
    intro: 'Don\'t miss the Johnathan Thurston farewell phenomenon',
    image: {
      // src: 'thurston_cover',
      // src: 'thurston_promo',
      src: 'thurston_promo_custom',
      alt: 'Johnathan Thurston, The Autobiogrphy',
    },
  },

  social: 'Say #ThanksJT on social, plus...',

  parts: [
    {
      type: 'message',
      title: 'Send JT a personal message — and nominate his No1 fan',
      link: 'https://www.123formbuilder.com/form-4066908/Tributes-To-JT',
      icon: IconSpeechbubble,
    },
    {
      type: 'book',
      // title: 'Beat the queue: pre-order JT\'s autobiography',
      title: 'Pre-order JT\'s autobiography',
      subtitle: 'Hard copy',
      // link: 'https://www.booktopia.com.au/jt-johnathan-thurston/prod9781460752609.html',
      link: 'https://www.qbd.com.au/johnathan-thurston-the-autobiography/johnathan-thurston-with-james-phelps/9781460752609/',
      icon: IconShoppingcartAdd,
    },
    {
      type: 'ebook',
      title: 'Pre-order JT\'s autobiography',
      subtitle: 'Apple iBooks',
      link: 'https://itunes.apple.com/au/book/johnathan-thurston-autobiography/id1372600868?mt=11',
      icon: IconShoppingcartAdd,
    },
    {
      type: 'tour',
      title: 'The JT speaking tour',
      subtitle: 'Dates, venues, tickets',
      link: 'https://www.majoreventscompany.com/shows',
      icon: IconSpeakerPodium,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/content/projects/0817-thurston-links.js